import { Colors } from './baseColors';
import { solidAshColors } from './solidAshColors';

export const solidMarbleColors: Colors = { ...solidAshColors };
